import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, output, SimpleChange } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerRestService } from '../../../../services/member-insurer-rest.service';
import { MemberInsurerServiceService } from '../../../../services/member-insurer-service.service';
import { AddMemberComponent } from '../../../add-member/add-member.component';
import { NotificationService } from '../../../shared/services/notifications.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Roles } from '../../../../models/commonmodel';
import { ConfirmationMode } from '../../../shared/share';
import { CustomDateAdapter } from '../../../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../../../shared/pipes/date-format';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ConfirmationmodalComponent } from '../../../shared/components/confirmationmodal/confirmationmodal.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-common-admin-component',
  standalone: true,
  imports: [MatFormFieldModule, ReactiveFormsModule, CommonModule, MatInputModule, MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule],
  templateUrl: './common-admin-component.component.html',
  styleUrl: './common-admin-component.component.scss',
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
   animations: [
    trigger('userCardAnimation', [
      state('unselected', style({
        transform: 'scale(1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        borderColor: 'transparent'
      })),
      state('selected', style({
        transform: 'scale(1.03)',
        borderColor: '#0075C9',
        background: 'linear-gradient(157deg, rgb(0 117 201 / 0%), rgb(102 174 224 / 20%))'
      })),
      transition('unselected <=> selected', [
        animate('250ms ease-in-out')
      ]),
    ])
  ]
})
export class CommonAdminComponentComponent {

  
    insurerForm: FormGroup;
    popupTitle = 'Add Admins';
    popupSubtitle = 'Please provide the information below to add a new admins.';
    isSubmitLoading: boolean = false;
    enumConfirmationMode = ConfirmationMode;
    userAccess = this.memberService.getUserAccess();
    value:string='';
    enumRole = Roles;
    today = new Date();
    userRole = this.memberService.getLoginUserRole();
    @Input() isDismissable: boolean = false;
    @Output ()  orgrole =new EventEmitter<any>();
    imagePreviewUrl: string | ArrayBuffer | null = null;
    
      adminProviderList: any[] = [];
      distributororg:any[]=[];
      adminInsurerList:any[]=[];
    editedAdmin: any;
    constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddMemberComponent>, private dialog: MatDialog,
      private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private datepipe: DatePipe,
      private notificationService: NotificationService, @Inject(MAT_DIALOG_DATA) public data: any
    ) {
  
      if (data) {
        this.editedAdmin = data;
      }
  
      this.insurerForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        dateOfBirth: [''],
        gender: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
        address: ['', Validators.required],
        organisationName: ['ORG35D51',Validators.required],
        imgLogoUrl: [''],
        activeEndDate:['',],
        activeStartDate:['',Validators.required],
        adminType: ['',Validators.required],
        addedBy: ['']
      });
  
    }
    ngOnInit() {
  
      if (this.editedAdmin) {
        this.insurerForm.get('firstName')?.disable();
        this.insurerForm.get('lastName')?.disable();
        this.preFillForm(this.editedAdmin);
      } else {
        this.insurerForm.get('firstName')?.enable();
        this.insurerForm.get('lastName')?.enable();
      }
        this.getAdminProviders();
      this.getAdminInsurer();
      this.getDistributorOrg();
      const orgType =this.insurerForm.get('adminType');
      orgType?.valueChanges.subscribe(value =>{
        this.orgrole.emit(value)
      })

      
    }

    ngOnChanges(change:SimpleChange){
      if(this.insurerForm.get('adminType')?.value==='ADMIN_DISTRIBUTOR'){
        this.getAdminInsurer()
      }

    }
  
    preFillForm(data: any): void {
      if (data && this.insurerForm) {
        this.popupTitle = 'Edit Admin Insurer';
        this.popupSubtitle = 'Please provide the information below to edit admin insurer.';
  
        this.insurerForm.patchValue({
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          dateOfBirth: data.dateOfBirth ? this.formatDate(data.dateOfBirth) : null,
          gender: data.gender || '',
         activeStartDate: data.activeStartDate || '',
         activeEndDate:data.activeEndDate || ' ',
         
          email: data.email || '',
          phone: data.phone || '',
          
          address: data.address || '',
          organisationName: data.org.orgId || '',
          imgLogoUrl: data.imgLogoUrl || '',
           adminType: data.role || '',
           // Static as per form definition
          //  role: 'ADMIN_DISTRIBUTOR',
          addedBy: data.createdby || 'SUPER_ADMIN'
        });
        this.selectProvider(data.org.orgId)
      console.log(this.selectedProviderIds)
      }
  
      this.imagePreviewUrl = this.editedAdmin?.imgLogoUrl || null;
  
      if (data.providers && Array.isArray(data.providers)) {
        this.selectedProviderIds = [...data.providers]; // Clone to avoid mutation
        console.log("selected",this.selectedProviderIds);
      }
    }
  
    formatDate(dateStr: string): Date | null {
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const [day, month, year] = parts.map(Number);
        return new Date(year, month - 1, day);
      }
      return null;
    }


    getAdminInsurer(){
      this.adminInsurerList=[];
      this.restService.getInsurerOrg().subscribe({
        next:(response)=>{
           if (response.length > 0) {
            // Only keep providers where isActive is true (or not false)
            this.adminInsurerList = response.filter( (res: { isactive: boolean; }) => res.isactive !== false);
          }

        },
        error:(err)=>{
          console.log(err.message)
        }
      })
    }
  
   getDistributorOrg(){
      this.distributororg=[];
      this.restService.getDistributorOrg().subscribe({
        next:(response)=>{
           if (response.length > 0) {
            // Only keep providers where isActive is true (or not false)
            this.distributororg = response.filter( (res: { isactive: boolean; }) => res.isactive !== false);
          }

        },
        error:(err)=>{
          console.log(err.message)
        }
      })
    }
    getAdminProviders() {
      this.adminProviderList = [];
      this.restService.getProviderOrganisation().subscribe({
        next: (response: any[]) => {
          if (response.length > 0) {
            // Only keep providers where isActive is true (or not false)
            this.adminProviderList = response.filter(p => p.isactive !== false);
          }
        },
        error: () => {
          this.adminProviderList = [];
        }
      });
    }
  
  
    selectedProviderIds: string[] = [];
  
    selectProvider(user: any) {
      const index = this.selectedProviderIds.indexOf(user.orgId);
      console.log(this.selectedProviderIds)

      if (index > -1) {
        // Already selected → deselect
        this.selectedProviderIds.splice(index, 1);
      } else {
        // Not selected → add
        this.selectedProviderIds.push(user.orgId);
        this.insurerForm.patchValue({organisationName:user.orgId})
      }
    }
  
    previewImage(file: File) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreviewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  
    previewImageby(url: any) {
      this.imagePreviewUrl = url;
    }
  
  
    onFileInputClick() {
      console.log("clicked");
      // this.backButton();
    }
  
    onFileDropped(event: Event) {
      event.preventDefault();
      const dragEvent = event as DragEvent;
      const files = dragEvent.dataTransfer ? dragEvent.dataTransfer.files : null;
      console.log(files);
      if (files && files.length > 0) {
        // this.handleFiles(files);
      }
    }
  
    fileUploaded: any;
    async onAssetImage(event: any) {
      const file = event.files[0];
      console.log(file);
      this.fileUploaded = file;
      this.previewImage(file);
      const url = await this.getfiles3Url(file);
      this.insurerForm.get('imgLogoUrl')?.patchValue(url.documentPath);
    }
  
    getfiles3Url(file: File): Promise<any> {
      return new Promise((resolve, reject) => {
        this.restService.uploadFile(file).subscribe(
          (response) => resolve(response),
          (error) => reject(error)
        );
      });
    }
  
  
    closeDialog() {
      this.dialogRef.close(true)
             
  
            
  

    }
  
    onsubmit() {
      if (this.insurerForm.valid) {

        const payloadvalues=this.insurerForm.getRawValue();
        console.log( payloadvalues.firstName)
        this.isSubmitLoading = true;
        const newKey = this.editedAdmin?.id ? 'updatedby' : 'createdby';
            console.log( "the id are " + this.selectedProviderIds)
            if(this.editedAdmin?.id){
             
            }
            else{
             this. value="createdby"
            }
  
            const newpayload={
  
          
    "firstName": payloadvalues.firstName,
    "lastName": payloadvalues.lastName,   
    "name": payloadvalues.firstName + payloadvalues.lastName ,
    "dateOfBirth": payloadvalues.dateOfBirth
            ? this.datepipe.transform(payloadvalues.dateOfBirth, 'yyyy-MM-dd')
            : '',
    "gender": payloadvalues.gender,
    "email": payloadvalues.email,
    "phone": payloadvalues.phone,
    "address": payloadvalues.address
    ,
    "yearsOfExperience": 5,
    "role": payloadvalues.adminType,
    "activeStartDate":  payloadvalues.activeStartDate ? this.datepipe.transform(payloadvalues.activeStartDate, 'yyyy-MM-dd')
        : '',
    "activeEndDate": payloadvalues.activeEndDate ? this.datepipe.transform(payloadvalues.activeEndDate, 'yyyy-MM-dd')
        : '',
        
    "orgId": payloadvalues.organisationName
  
            }
        // Create payload from form values
       
   const modifypayload={[newKey]:this.memberService.getLoginUserId(),...newpayload};
   console.log("the modifypayload");
   console.log(modifypayload)
        const isEditMode = this.editedAdmin?.id;
  
        const apiCall = isEditMode
          ? this.restService.editAdminsCommon(modifypayload, this.editedAdmin.userId)
          : this.restService.addAdminsCommon(modifypayload);
  
           const dialogConfig = new MatDialogConfig();
                    dialogConfig.width = '350px';
                    dialogConfig.disableClose = true;
                    dialogConfig.autoFocus = false;
                
                    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
                    dialogRef.componentInstance.title = 'Confirm';
                    dialogRef.componentInstance.mode = 'Add';
                    dialogRef.componentInstance.message = 'Are you sure you want to Add The AdminInsurer';
                    dialogRef.afterClosed().subscribe((res)=>{
                      console.log( "the response " + res)
           if(res){
        apiCall.subscribe({
          next: (response) => {
            this.isSubmitLoading = false;
            if (response) {
              this.notificationService.showNotification(
                isEditMode ? 'Admin Insurer updated successfully' : 'Admin Insurer added successfully'
              );

              if(response.role==='ADMIN_INSURER'){
                              this.memberService.emitRefreshAdminInsurer();

              }
              else if(response.role==='ADMIN_PROVIDER'){
                              this.memberService.emitRefreshAdminProvider();

              }
              else if(response.role==='ADMIN_DISTRIBUTOR'){
                              this.memberService.emitRefreshAdminDistributor()

              }
              
              this.dialogRef.close(true );
              this.dialogRef.close()
            } else {
              this.notificationService.showNotification(
                response.message || (isEditMode ? 'Failed to update Admin Insurer' : 'Failed to add Admin Insurer'),
                'error'
              );
            }
          },
          error: (error) => {
            this.isSubmitLoading = false;
            this.notificationService.showNotification(error.error?.message || 'An error occurred', 'error');
          }
        });}
        else if(!res){
                                this.isSubmitLoading = false;


          // this.dialogRef.close()

        }
      
      })
      }
    }
  

}
